// 个人信息组件
export default {
  // 页面标题
  userCenter: "用户中心",

  // 按钮
  edit: "修改",
  save: "保存",
  unbind: "解绑",
  scanToBinding: "扫码绑定",

  // 表单标签
  username: "用户名",
  phoneNumber: "手机号",
  createTime: "创建时间",
  account: "账号",
  email: "邮箱",
  modifiedTime: "更改时间",
  wechat: "微信",

  // 状态文本
  notBound: "未绑定",
  bound: "已绑定",
  noPhone: "暂无号码",

  // 表单验证
  usernameLengthRule: "长度在 2 到20 个字符",
  phoneLengthRule: "长度在 7 到11 个字符",
  emailRequired: "请输入邮箱地址",
  emailFormat: "请输入正确的邮箱地址",

  // 提示消息
  unbindConfirm: "是否解除已绑定的微信用户?",
  tip: "提示",
  yes: "是",
  no: "否",
  unbindSuccess: "解绑成功",
  unbindCancelled: "已取消解绑",
  editSuccess: "修改成功",
  saveNotEmpty: "保存不能为空",
  phoneBinding: {
    bindPhone: "绑定手机号",
    changePhone: "更换手机号",
    notBoundTip: "您的账户还未绑定手机号，",
    goToBind: "前往绑定",
    bindTitle: "手机号绑定",
    changeTitle: "更换手机号",
    oldPhoneLabel: "旧手机号",
    newPhoneLabel: "新手机号",
    smsCodeLabel: "短信验证码",
    cancel: "取消",
    confirm: "确认",
    nextStep: "下一步",
    bindSuccess: "手机号绑定成功",
    changeSuccess: "手机号更换成功",
  },
};
